import { createFileRoute } from '@tanstack/react-router'
import { FraudAnalysisUploadPage } from 'features/fraudAnalysis'

export const Route = createFileRoute('/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/upload')({
  component: FraudAnalysisUploadPage,
})
